import { ApplicationAnalytics, ApplicationInsights, ICustomProperties, IExceptionTelemetry, IPageViewTelemetry } from "@microsoft/applicationinsights-web";

import { getConfig } from "../getConfig";
import { getEnvironmentName } from "../getEnvironmentName";

const initAppInsights = (): ApplicationInsights | null => {
    if (typeof localStorage === "undefined") {
        // avoid calling app insights in tests
        return null;
    }

    const environmentName = getEnvironmentName();
    if (environmentName === "Development") {
        return null;
    }

    const config = getConfig();

    if (!config.AppInsightsConnectionString) {
        // avoid calling app insights for data download which is passing connection string as null
        return null;
    }

    const ai = new ApplicationInsights({ config: {
        connectionString: config.AppInsightsConnectionString
    } });
    ai.loadAppInsights();
    ai.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview

    return ai;
};

const appInsights: ApplicationInsights | null = initAppInsights();

export const trackException = (exception: IExceptionTelemetry, customProperties?: ICustomProperties) => {
    if (appInsights && appInsights.trackException) {
        appInsights.trackException(exception, customProperties);
    }
};

export const setAuthenticatedUserContext = (authenticatedUserId: string, accountId?: string, storeInCookie?: boolean) => {
    if (appInsights && appInsights.setAuthenticatedUserContext) {
        appInsights.setAuthenticatedUserContext(authenticatedUserId, accountId, storeInCookie);
    }
};

export const getApplicationAnalytics: () => ApplicationAnalytics | undefined = () => appInsights?.appInsights;

export const trackPageView = (pageView?: IPageViewTelemetry) => {
    if (appInsights && appInsights.trackPageView) {
        appInsights.trackPageView(pageView);
    }
};
